import { render, staticRenderFns } from "./transAddress.vue?vue&type=template&id=4ca76422&scoped=true&"
import script from "./transAddress.vue?vue&type=script&lang=js&"
export * from "./transAddress.vue?vue&type=script&lang=js&"
import style0 from "./transAddress.vue?vue&type=style&index=0&id=4ca76422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca76422",
  null
  
)

export default component.exports